module.exports = __webpack_public_path__ + "img/weixiu.ab06911a.png";